<template>
  <v-list theme="dark" bg-color="transparent" active-class="text-white">
    <v-list-item
      v-for="(route, idx) in routes"
      :key="idx"
      :to="route.path"
      :data-testid="route.label"
    >
      <v-badge
        :model-value="!!route.showIndicator"
        color="error"
        dot
        location="end center"
        class="test-admin-badge w-100"
      >
        <v-list-item-title>{{ route.label }}</v-list-item-title>
      </v-badge>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const store = sl.get('store');

    const routes = computed(() => [
      {
        label: 'Groups',
        path: '/admin/groups',
      },
      {
        label: 'Public Denylist',
        path: '/admin/denylist/texts',
      },
      {
        label: 'Quarantined Texts',
        path: '/admin/quarantine',
      },
      {
        label: 'Error Log',
        path: '/admin/errors',
        showIndicator: store.getters.displayAdminBadge.error,
      },
      {
        label: 'Comments',
        path: '/admin/comments',
        showIndicator: store.getters.displayAdminBadge.comments,
      },
      {
        label: 'Text Drafts',
        path: '/admin/drafts',
      },
      {
        label: 'Properties Taxonomy',
        path: '/admin/properties',
      },
      { label: 'Site Analytics', path: '/admin/analytics' },
      {
        label: 'Admin Settings',
        path: '/admin/settings',
      },
    ]);

    return {
      routes,
    };
  },
});
</script>
